import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from './app/reducers';
import prevUrlMiddlewares from './utils/middlewares/prevUrlMiddlewares';

const isDevTools =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    process.env.NODE_ENV !== 'production';

const composeEnhancers = isDevTools ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

export default function configureStore (initialState, browserHistory = null) {
  const middlewares = [prevUrlMiddlewares, thunk];
  if (browserHistory) {
    middlewares.push(routerMiddleware(browserHistory));
  }

  const enhancer = composeEnhancers(
    applyMiddleware.apply(null, middlewares)
  );

  return createStore(rootReducer, initialState, enhancer);
}



// WEBPACK FOOTER //
// ./src/store.js